function bookingsForDayOfWeek(dayOfWeek, eventBookings) {
  return eventBookings.filter(booking => {
    const startsAtDate = booking.attributes.startsAt
    const startsAtDayOfWeek = new Date(startsAtDate).toLocaleString('en-US', { weekday: 'long' }).toLowerCase()
    if (startsAtDayOfWeek === dayOfWeek.toLowerCase()) {
      return true;
    }
    return false;
  })
}

export default bookingsForDayOfWeek;
